import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-50 py-14 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-white">Vigorbuy Spreadsheet Hub</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-xs">
              The most complete Vigorbuy Spreadsheet resource center. Organized product discovery, shopping guides, and expert recommendations — all in one place.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-foreground-400 text-sm hover:text-white transition-colors whitespace-nowrap">Home</Link></li>
              <li><Link to="/vigorbuy-spreadsheet-guide" className="text-foreground-400 text-sm hover:text-white transition-colors whitespace-nowrap">Complete Guide</Link></li>
              <li><a href="#categories" className="text-foreground-400 text-sm hover:text-white transition-colors whitespace-nowrap">Categories</a></li>
              <li><a href="#safety" className="text-foreground-400 text-sm hover:text-white transition-colors whitespace-nowrap">Safety Information</a></li>
              <li><a href="#faq" className="text-foreground-400 text-sm hover:text-white transition-colors whitespace-nowrap">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">Popular Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-sm hover:text-white transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-foreground-500 text-xs">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-white transition-colors whitespace-nowrap"
            >
              Main Website
            </a>
            <Link to="/vigorbuy-spreadsheet-guide" className="hover:text-white transition-colors whitespace-nowrap">
              Vigorbuy Spreadsheet Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}